import styled from "styled-components";

export const ResellerPageStyle = styled.div`
  .details-div {
    display: flex;
    font-family: thin-pro, sans-serif;
  }
  .details-div2 {
    display: flex;
    font-family: thin-pro, sans-serif;
    margin-left: 15px;
  }

  .detail-heading {
    font-weight: bold;
    font-family: medium-pro, sans-serif !important;
  }
  .detail-heading2 {
    font-weight: 500;
    font-family: medium-pro, sans-serif !important;
  }

  .load-div {
    font-size: 14px;
    font-family: medium-pro, sans-serif;
    text-align: center;
    color: #f28809;
  }

  .download-div3 {
    display: flex;
    justify-content: end;
    font-family: medium-pro, sans-serif !important;
  }

  .text-error2 {
    font-family: thin-pro, sans-serif;
    color: red;
    font-size: 14px;
    align-self: center;
    text-align: center;
    margin-top: 10px;
  }

  .table-div {
    padding: 20px;
    width: 80%;
    display: flex;
    height: 540px;
    overflow-y: auto;
    margin-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
  }
  .table-div2 {
    padding: 20px;
    display: flex;
    height: 430px;
    overflow-y: auto;
    margin-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
    font-family: medium-pro, sans-serif;
  }

  .item2 {
    font-family: thin-pro, sans-serif;
  }
  .table-head {
    position: sticky;
    top: -20px;
    background: white;
  }

  .table-loading {
    text-align: center;
    font-size: 1rem;
  }

  .action-items {
    display: flex;
    justify-content: space-between;
    width: 80%;
  }

  .edit-icon {
    font-size: 1.2rem;
    color: #4cdb4c;
  }

  .view-icon {
    font-size: 1.2rem;
    color: #f28809;
  }

  .add-icon {
    font-size: 23px;
    color: #f28809;
    margin-right: 10px;
  }

  .delete-icon {
    font-size: 1.2rem;
    color: #dd3e3e;
  }

  .add2-icon {
    font-size: 1.6rem;
    margin-top: 20px;
    margin-bottom: 20px;
    color: white;
  }

  .form-button {
    width: 100px;
    background-color: hsl(33, 93%, 54%);
    border-color: white;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 16px;
    padding: 2px 0;
    align-self: center;
  }

  .modal-header2 {
    text-align: center;
    margin-bottom: 25px;
    font-weight: 500;
  }
  .bootstrap-btn {
    font-family: medium-pro, sans-serif !important;
    margin-bottom: 0;
  }
  .form-button3 {
    width: 13vh;
    background-color: hsl(33, 93%, 54%);
    border-color: white;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 16px;
    padding: 7px 0;
    align-self: center;
  }
  .form-button2 {
    width: 45vh;
    background-color: hsl(33, 93%, 54%);
    border-color: white;
    margin-top: 20px;
    margin-bottom: 10px;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 16px;
    padding: 10px 0;
    align-self: center;
  }
  .form-button-disable {
    background-color: #bcb7b7;
  }

  .reseller-container {
    background-color: white;
    width: 48vh;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    padding: 20px 60px;
    box-shadow: 0 0 30px rgba(247, 148, 29, 0.3); /* Add a box shadow */
    align-self: center;
    margin-top: 30px;
  }

  .text-login {
    margin-top: 5px;
    font-family: medium-pro, sans-serif;
  }

  .error-input {
    height: 4vh;
    margin-bottom: 5px;
    font-family: light-pro, sans-serif;
    border-color: red;
    width: 80%;
  }

  .input-field {
    height: 4vh;
    margin-bottom: 5px;
    width: 80%;
    font-family: light-pro, sans-serif;
    font-size: 15px;
    :focus {
      border-color: white;
      box-shadow: 0 0 5px #f7951d;
    }
  }

  .input-div {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .add-button {
    width: 50px;
    background-color: hsl(33, 93%, 54%);
    border-color: white;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 15px;
    padding: 10px 0;
  }

  .add-button-disable {
    background-color: #bcb7b7;
  }

  .disable-icon {
    pointer-events: none;
    color: #bcb7b7;
  }

  .table-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 10px;
    font-family: medium-pro, sans-serif;
  }
  .table-container3 {
    width: 90%;
    display: flex;
    align-self: center;
    flex-direction: column;
    font-family: medium-pro, sans-serif;
  }
  .detail-main {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-self: left;
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 50px;
    margin-left: 10%;
    font-family: medium-pro, sans-serif;
  }

  .space-reseller {
    margin-bottom: 50px;
  }

  .heading-icon {
    color: #f28809;
  }

  .btn-div {
    justify-content: end;
    display: flex;
  }

  .table-item {
    font-size: 1rem;
  }

  .table-item2 {
    font-family: thin-pro, sans-serif;
  }
  @media screen and (max-width: 600px) {
    .table-div {
      width: 100%;
    }
  }
  /* For large devices */
  @media screen and (max-width: 1024px) {
    .table-item {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 1440px) {
    .table-item {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 500px) {
    .table-item {
      font-size: 0.5rem;
    }
  }
`;
